Customer.Users ||= {}

class Customer.Users.ProfileRowView extends Backbone.View
  template: JST["backbone/templates/customer/users/profile_row"]

  initialize: (@options = {}) ->
    @profile = @options.profile

  render: ->
    @$el.html(@template(profile: @profile))
    return this